import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslateService } from '@ngx-translate/core';
import { slideDownUp } from '../shared/animations';
import { environment } from 'src/environments/environment';

import { SharedModule } from 'src/shared.module';
import { NgClass } from '@angular/common';

@Component({
    selector: 'sidebar',
    templateUrl: './sidebar.html',
    animations: [slideDownUp],
    standalone: true,
    imports: [SharedModule, NgClass]
})
export class SidebarComponent implements OnInit {
    active = false;
    store: any;
    activeDropdown: string[] = [];
    logoPath = environment.logoPath;
    readonly featureFlags = environment.featureFlags ?? {
        qualification: { enabled: false, visible: false },
        audit: { enabled: false, visible: false },
        calibration: { enabled: false, visible: false },
        inspectionLog: { enabled: false, visible: false },
        maintenance: { enabled: false, visible: false },
        pmc: { enabled: false, visible: false },
        stampControl: { enabled: false, visible: false },
        equipment: { enabled: false, visible: false },
        document: { enabled: false, visible: false },
        user: { enabled: false, visible: false },
        method: { enabled: false, visible: false },
    };
    public translate = inject(TranslateService);
    public storeData = inject<Store<any>>(Store);
    public router = inject(Router);

    ngOnInit() {
        this.initStore();
        this.setActiveDropdown();
    }

    async initStore() {
        this.storeData
            .select((d) => d.index)
            .subscribe((d) => {
                this.store = d;
            });
    }

    setActiveDropdown() {
        const selector = document.querySelector('.sidebar ul a[routerLink="' + window.location.pathname + '"]');
        if (selector) {
            selector.classList.add('active');
            const ul: any = selector.closest('ul.sub-menu');
            if (ul) {
                let ele: any = ul.closest('li.menu').querySelectorAll('.nav-link') || [];
                if (ele.length) {
                    ele = ele[0];
                    setTimeout(() => {
                        ele.click();
                    });
                }
            }
        }
    }

    toggleMobileMenu() {
        if (window.innerWidth < 1024) {
            this.storeData.dispatch({ type: 'toggleSidebar' });
        }
    }

    toggleAccordion(name: string) {
        if (this.activeDropdown.includes(name)) {
            this.activeDropdown = this.activeDropdown.filter((d) => d !== name);
        } else {
            this.activeDropdown.push(name);
        }
    }
}

